import Loading from '@/components/ui/Loading';
import SignUpForm from '@/pages/auth/components/SignUpForm';
import { useAuthProvider } from '@/pages/auth/hooks/useAuthProvider';

export default function SignUp() {
	const { handleSignUp, loadingState } = useAuthProvider();

	if (loadingState.signUp) {
		return (
			<div className="flex-1">
				<Loading />
			</div>
		);
	}

	return (
		<div className="flex-1">
			<SignUpForm
				handleSubmit={handleSignUp}
				loading={loadingState.signUp}
				signUpTitle={'Sign up'}
			/>
		</div>
	);
}
